// extracted by mini-css-extract-plugin
export default {"content":"ContractPartnersList_content__xR7Yx","search":"ContractPartnersList_search__07uSy"};